import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-item__content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "custom-item__content__des" }
const _hoisted_4 = { class: "custom-item__content__des__text" }
const _hoisted_5 = {
  key: 0,
  class: "custom-item__content__des__tag"
}

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'customItem',
  props: {
    imgUrl: null,
    des: null,
    selectedFlag: { type: Boolean, default: false },
    tag: null,
    imgHeight: { default: 70 },
    imgWidth: { default: 130 }
  },
  setup(__props: any) {

const props = __props as { imgUrl: string, des: string, selectedFlag: boolean, tag?: string, imgHeight: number, imgWidth: number }

_useCssVars(_ctx => ({
  "0fc7867e": (_unref(imgWidth)),
  "614b6122": (_unref(imgHeight))
}))


const imgHeight = computed(() => props.imgHeight + 'px')
const imgWidth = computed(() => props.imgWidth + 'px')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-item", __props.selectedFlag ? 'custom-item__click' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: props.imgUrl,
        alt: "custom-image"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.des), 1),
        (props.tag)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.tag), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})